// The label/helper text StepPersonal's alternate-email field shows differs
// per host screen (see the frontend guide's screen table). Centralised here
// so each host's choice is a one-line import instead of a hand-typed string,
// and so the "bulk review is stored-only, never emailed" copy decision is
// assertable without rendering the whole (heavy) bulk review page.
export const ALTERNATE_EMAIL_COPY = {
  apply: {
    label: "Alternate email (optional)",
    helperText: "We will send the confirmation link to both addresses.",
  },
  reupload: {
    label: "Candidate's alternate email (optional)",
    helperText: "We will send the confirmation link to both addresses.",
  },
  bulkReview: {
    label: "Alternate email (optional)",
    helperText: "Stored on the candidate's record. No email is sent to this address.",
  },
  editProfile: {
    label: "Alternate email (optional)",
    helperText: "Applies to this application only.",
  },
};
